import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { SplitFactory } from '@splitsoftware/splitio';
var isServer = typeof window === 'undefined';
export var SplitFeatureToggles = function () {
  var client;
  var factory;
  var toggleRequestedCallback;
  var clientId = 'unknow';

  function setToggleCallback(func, force) {
    if (force || !toggleRequestedCallback) {
      toggleRequestedCallback = func;
    }
  }

  function initialize(_x) {
    return _initialize.apply(this, arguments);
  }

  function _initialize() {
    _initialize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(authorizationKey) {
      var instance;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (authorizationKey) {
                _context.next = 3;
                break;
              }

              console.log('Split is not connected, please provide an authorization key');
              return _context.abrupt("return");

            case 3:
              if (!client) {
                _context.next = 6;
                break;
              }

              console.log('Client is already initialized');
              return _context.abrupt("return");

            case 6:
              _context.prev = 6;
              _context.next = 9;
              return SplitFactory({
                core: {
                  authorizationKey: authorizationKey,
                  key: clientId
                }
              });

            case 9:
              factory = _context.sent;
              instance = factory.client();
              _context.next = 13;
              return instance.ready();

            case 13:
              client = instance;
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](6);
              console.log('Error initializing SplitIO: ', _context.t0);

            case 19:
              return _context.abrupt("return");

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 16]]);
    }));
    return _initialize.apply(this, arguments);
  }

  function getToggle(treatment, attributes, defaultValue) {
    if (defaultValue === void 0) {
      defaultValue = false;
    }

    if (!client) {
      return {
        isEnabled: function isEnabled() {
          return defaultValue;
        },
        getValue: function getValue() {
          return null;
        }
      };
    }

    var treatmentValue = isServer ? client.getTreatment(clientId, treatment, attributes) : client.getTreatment(treatment, attributes);
    if (toggleRequestedCallback) toggleRequestedCallback({
      name: treatment,
      value: treatmentValue
    });
    return {
      isEnabled: function isEnabled() {
        return treatmentValue === 'on';
      },
      getValue: function getValue() {
        return treatmentValue;
      }
    };
  }

  function setClientId(id) {
    if (clientId === 'unknow') {
      clientId = id;
    }
  }

  return {
    initialize: initialize,
    getToggle: getToggle,
    client: client,
    setClientId: setClientId,
    setToggleCallback: setToggleCallback
  };
}();